import { useIsEpocusPlatformAdmin } from "../../_lib/rbac/epocus-claim";

export const useCanAdministerEpocus = (): boolean => useIsEpocusPlatformAdmin();
